<template>
  <div class="container-md">
    <hr class="bg-muted">
    <div v-if="!isTramitado" class="form-group row">
      <div class="col-sm-2">
        <label>Interessados: <span class="text-danger">*</span></label>
      </div>
      <div class="col-sm-10">
        <div class="input-group">
          <select class="form-control center-select" v-model="active">
            <option v-for="(item, indice) in select.tipoInteressados" :key="indice" :value="item.tipoInteressado">{{ item.tipoInteressado }}</option>
          </select>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" @click=" () => {
              isManterContatoExterno = false
              reniciarAlert()
              $refs.interessados.openModal()
            }">PROCURAR</button>
          </div>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" @click=" () => {
              isManterContatoExterno = true
              reniciarAlert()
              $refs.interessados.openModal()
            }">NOVO INTERESSADO</button>
          </div>
        </div>
      </div>
    </div>
    <modal ref="interessados"  width="1000px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="titulo">Interessados - {{ isManterContatoExterno ? 'Novo Contato' : active }}</h4>
          <i class="fa fa-times fa-1-5x" @click="$refs.interessados.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body" id="interessados-divisoria">
          <manterContatoExterno v-if="isManterContatoExterno" :backButtonIsVisible="false" />
          <div v-if="!isManterContatoExterno">
            <div class="container-md mt-1">
              <alert-comp :key="alert.key" :msg="alert" />
            </div>
            <component
              :key="active"
              v-bind:is="active"
              :progressName="active"
              :eventBusDataName="`${table.list.eventBusDataName}-${active}`"
              :eventBusPaginationName="`${table.list.eventBusPaginationName}-${active}`"
              :acceptUserDepartamento="true"
            ></component>

            <div class="container-md">
              <hr class="bg-muted">

              <list
                :eventData="`${table.list.eventBusDataName}-${active}`"
                :eventPagination="`${table.list.eventBusPaginationName}-${active}`"
                :onClick="adicionar"
              >
                <template v-slot:default="props">
                  <list-body :hover="props.hover" :data="props.data" :columns="props.columns">
                    <template v-slot:hover>
                      <span class="link">
                        <i
                          v-tooltip.auto-start="`Adicionar Interessado: ${props.data.nome || props.data.nomeEstrutura}`"
                          class="fa fa-plus fa-1-5x text-white m-1 link"
                          aria-hidden="true">
                        </i>
                      </span>
                    </template>
                  </list-body>
                </template>
              </list>
            </div>
          </div>
        </div>
      </template>
    </modal>

    <div>
      <h5>Interessados Selecionados</h5>

      <data-table-consulta-comp id="interessados" class="mt-3"
        :colNames="table.selected.colNames"
        :dataTableColumn="table.selected.dataTableColumn"
        :eventBusDataName="table.selected.eventBusDataName"
        :eventBusDataPaginationName="table.selected.eventBusPaginationName">

        <template v-slot:default="slotProps">
          <td v-if="!isTramitado" style="text-align: center; width: 100px !important;">
            <i class="fa fa-trash-o fa-1-5x link" aria-hidden="true" v-on:click="excluir(slotProps.itemData.nome)"></i>
          </td>
        </template>
      </data-table-consulta-comp>
    </div>
  </div>
</template>

<script>
import eventBus from '@/uteis/eventBus'
import DataValues from '@/components/data-table-consulta/DataValues'

import { mapState } from 'vuex'
import { toContantoExterno } from '@/uteis/converters/ProtocoloConverter'

import alertComp from '@/components/alert/AlertComp'
import modal from '@/components/shared/Modal'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'

import list from '@/components/list'
import body from '@/components/list/body'

import manterContatoExterno from '@/components/manter-processo/contatoExterno/manter/ManterContatoExterno'
import filtroPessoaFisica from '@/components/filtro-interessados/filtros/FiltroPessoaFisica'
import filtroPessoaJuridica from '@/components/filtro-interessados/filtros/FiltroPessoaJuridica'
import filtroPoderExecutivo from '@/components/filtro-interessados/filtros/FiltroPoderExecutivo'
import filtroServidor from '@/components/filtro-interessados/filtros/FiltroServidor'

export default {
  components: {
    dataTableConsultaComp,
    list,
    'list-body': body,
    alertComp,
    modal,
    manterContatoExterno,

    'Pessoa Fisica': filtroPessoaFisica,
    'Pessoa Juridica': filtroPessoaJuridica,
    Servidor: filtroServidor,
    'Poder Executivo Estadual': filtroPoderExecutivo
  },

  props: {
    isTramitado: { required: false, type: Boolean, default: false }
  },

  data () {
    return {
      active: 'Pessoa Fisica',
      alert: {
        type: '',
        texto: '',
        key: true
      },
      isManterContatoExterno: false,
      table: {
        list: {
          colNames: {
            'Pessoa Fisica': ['Tipo', 'Nome', 'CPF', 'Email', 'Ações'],
            'Pessoa Juridica': ['Tipo', 'Nome', 'CNPJ / IE', 'Email', 'Ações'],
            Servidor: ['Tipo', 'Nome', 'Matricula', 'Ações'],
            'Poder Executivo Estadual': ['Tipo', 'Nome Departamento', 'Sigla Departamento', 'Nome Gestor', 'Cidade', 'Ações']
          },
          dataTableColumn: {
            'Pessoa Fisica': [{ column: 'tipoContatoExterno', converter: 'tipoContatoExterno' }, 'nome', 'identificador', 'email'],
            'Pessoa Juridica': [{ column: 'tipoContatoExterno', converter: 'tipoContatoExterno' }, 'nome', 'identificador', 'email'],
            Servidor: [{ column: 'tipoContatoExterno', converter: 'tipoContatoExterno' }, 'nome', 'identificador'],
            'Poder Executivo Estadual': [{ column: 'tipoContatoExterno', converter: 'tipoContatoExterno' }, 'nomeEstrutura', 'siglaEstrutura', 'nomeUsuario', 'cidadeEstado']
          },
          eventBusDataName: 'listaInteressado',
          eventBusPaginationName: 'listaInteressadoPagination',
          rowsNumber: 5
        },
        selected: {
          colNames: ['Tipo', 'Nome', 'Identificador', 'Email', 'Ações'],
          dataTableColumn: [
            { column: 'tipoContatoExterno', converter: 'tipoContatoExterno' },
            'nome', 'identificador', 'email'
          ],
          eventBusDataName: 'listaInteressadoEscolhido',
          eventBusPaginationName: 'listaInteressadoEscolhidoPagination',
          rowsNumber: 5
        }
      },
      select: {
        tipoInteressados: [
          { id: 1, tipoInteressado: 'Pessoa Fisica', situacao: 'ATIVO' },
          { id: 2, tipoInteressado: 'Pessoa Juridica', situacao: 'ATIVO' },
          { id: 3, tipoInteressado: 'Servidor', situacao: 'ATIVO' },
          { id: 4, tipoInteressado: 'Poder Executivo Estadual', situacao: 'ATIVO' }
        ]
      }
    }
  },

  computed: {
    ...mapState({
      interessados: (state) => state.interessadosSelecionados
    })
  },

  watch: {
    interessados: function (newValue, oldValue) {
      if (this.interessados.length !== 0) {
        setTimeout(this.trocaDePagina, 200)
      }
    }
  },

  created () {
    if (this.$store.state.interessadosSelecionados.length !== 0) {
      setTimeout(this.trocaDePagina, 200)
    }
    eventBus.$on(this.table.selected.eventBusPaginationName, (page) => {
      this.trocaDePagina(page)
    })
  },

  destroyed () {
    eventBus.$off(this.table.list.eventBusPaginationName)
    eventBus.$off(this.table.selected.eventBusPaginationName)
  },

  methods: {
    listarContatos () {
      this.$router.push({ name: 'consultarContatoExterno' })
    },

    excluir (value) {
      var interessados = this.$store.state.interessadosSelecionados.filter(
        item => item.nome.toLowerCase() !== value.toLowerCase()
      )
      this.$store.commit('MUT_CONTATO_INTERESSADO', interessados)
      this.renderInteressados(interessados)
    },

    interessadoIsSelected (interessado) {
      if (interessado && interessado.identificador && interessado.identificador === '') {
        const item = this.$store.state.interessadosSelecionados.filter(item => item.identificador === interessado.identificador)
        return item.length !== 0
      }

      if (interessado && interessado.email) {
        const item = this.$store.state.interessadosSelecionados.filter(item => item.email === interessado.email)
        return item.length !== 0
      }

      if (interessado && interessado.nome) {
        const item = this.$store.state.interessadosSelecionados.filter(item => item.nome.toLowerCase() === interessado.nome.toLowerCase())
        return item.length !== 0
      }

      return true
    },

    toInteressado (obj) {
      if (obj.tipoContatoExterno !== 'Poder Executivo Estadual') {
        return obj
      }

      const orgao = this.$store.state.filtroDestinatario
      return {
        tipoContatoExterno: 'PODEREXECUTIVO',
        nome: `${orgao.siglaEstrutura} - ${obj.nomeEstrutura}`.trim(),
        identificador: obj.estruturaID,
        email: ''
      }
    },

    adicionar (obj) {
      const interessado = this.toInteressado(obj)

      if (this.interessadoIsSelected(interessado)) {
        this.alert = { type: 'danger', texto: 'Contato já adicionado', key: !this.alert.key }
        // Inserir scroll
        const el = document.getElementById('interessados-divisoria')
        el.scrollIntoView({ behavior: 'smooth' })
        return false
      }

      var interessados = [
        ...this.$store.state.interessadosSelecionados,
        { ...interessado, tipoContatoExterno: toContantoExterno(interessado.tipoContatoExterno).value }
      ]
      this.alert = { type: 'success', texto: `Interessado adicionado: ${interessado.nome}`, key: !this.alert.key }
      this.$store.commit('MUT_CONTATO_INTERESSADO', interessados)
      this.renderInteressados(interessados)
    },

    reniciarAlert () {
      this.alert = { type: '', texto: '', key: !this.alert.key }
    },

    renderInteressados (data, page = 1) {
      const dataValues = new DataValues(data, page, this.table.selected.rowsNumber)
      eventBus.$emit(this.table.selected.eventBusDataName, dataValues)
    },

    trocaDePagina (page = 1) {
      var interessados = this.$store.state.interessadosSelecionados
      this.renderInteressados(interessados, page)
    }
  }
}
</script>
